import moment from 'moment';
import isDate from 'lodash/isDate';
import keys from 'lodash/keys';
// import replace from 'lodash/replace';
export const getNowAsUtc = ()=>moment.utc(moment().format('YYYY-MM-DD HH:mm:ss'));
export const getWeekdays = ()=>keys(Array(7));
export const getDaysInMonth = (month, year)=>month ? moment(`${year || moment().year()}-${month}`, 'Y-M').daysInMonth() : 31;
export const getDays = (month, year)=>{
    const daysInMonth = getDaysInMonth(month, year);
    const days = [];
    for(let i = 1; i <= daysInMonth; i++){
        days.push(i);
    }
    return days;
};
export const getMonths = ()=>Array.apply(0, Array(12)).map((_, i)=>moment().month(i).format('MMMM'));
export const getYears = (yearsAgo = 120)=>{
    const currentYear = moment().year();
    const lastYear = currentYear - yearsAgo;
    const years = [];
    for(let i = currentYear; i > lastYear; i--){
        years.push(i);
    }
    return years;
};
// export const getD3LocaleDateFormat = () => {
//   const dict = {
//     DD  : '%d',
//     MM  : '%m',
//     YYYY: '%Y',
//   };
//   const localeFormat = moment.localeData().longDateFormat('L');
//   return replace(localeFormat, /DD|MM|YYYY/g, (matched) => dict[matched]);
// };
export const formatDate = (date, format = 'L')=>{
    if (!date) {
        return null;
    }
    return moment(new Date(date)).format(format);
};
export function formatTimestamp(timestamp, format = 'L', shouldDisplayAsLocal = true) {
    if (!timestamp) {
        return null;
    }
    const date = moment.unix(timestamp);
    return shouldDisplayAsLocal ? date.local().format(format) : date.utc().format(format);
}
export const formatDateAsObject = (date)=>{
    if (!date) {
        return null;
    }
    const momentDate = moment.utc(new Date(date)).local();
    return {
        day: momentDate.date(),
        month: momentDate.month() + 1,
        year: momentDate.year()
    };
};
export const getMomentDateFromObject = (obj)=>{
    if (!obj || !obj.day || !obj.month || !obj.year) {
        return null;
    }
    return moment().locale('en').year(obj.year).month(obj.month - 1).date(obj.day);
};
export const formatObjectAsDate = (obj)=>{
    if (!obj || !obj.day || !obj.month || !obj.year) {
        return null;
    }
    const momentDate = getMomentDateFromObject(obj);
    return momentDate.format('YYYY-MM-DD');
};
export const formatISODate = (date, isNoTime = false)=>{
    if (!date) {
        return null;
    }
    const momentDate = moment(isDate ? date : new Date(date));
    const utcOffset = momentDate.utcOffset();
    momentDate.utc();
    if (isNoTime) {
        momentDate.add(utcOffset, 'minutes').startOf('day');
    }
    return momentDate.locale('en').format();
};
// TODO: This logic shouldn't be here!
export const isMinor = (dateOfBirth, adultYears = 18)=>{
    let momentDate;
    if (typeof dateOfBirth === 'object') {
        momentDate = getMomentDateFromObject(dateOfBirth);
    } else if (typeof dateOfBirth === 'string') {
        momentDate = moment(new Date(dateOfBirth));
    }
    return momentDate.isAfter(moment().subtract(adultYears, 'years'));
};
